const init = () => {
    window.ConfirmationModal = (function () {
        let modalContainer = null
        let title = null
        let header = null
        let body = null
        let acceptButton = null
        let declineButton = null
        let hideDecline = null
        let size = null
        let top = null

        let isInitialized = false
        let defaultOptions = {
            title: 'Are you sure?',
            body: '',
            acceptLabel: 'OK',
            declineLabel: 'Cancel',
            hideHeader: false,
            hideDecline: false,
            size: '',
            top: null,
            onAccept: function () {

            },
            onDecline: function () {

            }
        }

        let init = function () {
            let template = `
            <div class="modal-back"></div>
            <div class="modal">
                <header class="modal-header"><h2 class="modal-title"></h2></header>
                <div class="content">
                    <p class="modal-body-text">Modal body text goes here.</p>
                    <footer>
                        <a class="btn decline">Cancel</a>
                        <a class="btn primary accept">Confirm</a>
                    </footer>
                </div>
            </div>`

            modalContainer = document.createElement('div')
            modalContainer.classList.add('confirmation-modal');
            modalContainer.innerHTML = template

            document.getElementsByTagName('body')[0].appendChild(modalContainer)
            title = modalContainer.getElementsByClassName('modal-title')[0]
            body = modalContainer.getElementsByClassName('modal-body-text')[0]
            acceptButton = modalContainer.getElementsByClassName('accept')[0]
            declineButton = modalContainer.getElementsByClassName('decline')[0]
            header = modalContainer.getElementsByClassName('modal-header')[0]
            isInitialized = true;
        }

        let hide = function () {
            modalContainer.style.display = 'none'
        }

        let isVisible = function () {
            return modalContainer !== null && modalContainer.style.display === 'block'
        }

        let show = function (options) {
            options = options || {}
            if (!isInitialized) {
                init()
            }
            let config = Object.assign({}, defaultOptions, options)
            title.innerHTML = config.title
            body.innerHTML = config.body
            acceptButton.innerHTML = config.acceptLabel
            declineButton.innerHTML = config.declineLabel
            acceptButton.onclick = function () {
                if (config.hideOnAccept === undefined || config.hideOnAccept) {
                    hide()
                }
                config.onAccept()
            }
            declineButton.onclick = function () {
                hide()
                config.onDecline()
            }
            modalContainer.style.display = 'block'

            if (config.top) {
                $(modalContainer).find('.modal')[0].style.top = config.top
            }

            config.hideHeader ? header.style.display = 'none' : header.style.display = 'block'
            config.hideDecline ? declineButton.style.display = 'none' : declineButton.style.display = 'inline-block'
            if (config.bgOpaque) modalContainer.classList.add('bg-opaque');
            	
            $(header).closest('.modal').addClass(config.size)
        }

        return {
            show: show,
            hide: hide,
            isVisible: isVisible
        }
    })()
}

export default {
    init
}

